export { getPortalHomeRoutes } from './routes';
